import { Duration } from "luxon";

export const getDuration = ({ duration }: { duration: string | null }) => {
  if (!duration) {
    return Duration.fromObject({ minute: 0 });
  }

  return Duration.fromISO(duration);
};

export default getDuration;
